import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-phone-click';

/**
 * When user clicks on request a call button at the end of self serve flow
 */
export function trackHelpCenterPhoneClick(
  retailerToken: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken, brandToken },
  });
}
